import { createContext, useContext, useEffect, useState } from 'react'
import { useStateCallback } from 'hooks'
import { clearObject } from 'lib/utils'
import useTaskApis from 'hooks/useTaskApis'
import {
  CS_CALL_CLIENT,
  CS_ISSUE_MANAGER,
  CS_MEET_CLIENT,
  MISSING
} from 'constants/events'

export const TaskStoreContext = createContext({
  taskStore: {},
  taskStoreFunc: {}
})

const INIT_FILTER = {
  globalId: '',
  types: [CS_CALL_CLIENT, CS_MEET_CLIENT, MISSING, CS_ISSUE_MANAGER],
  contactFullname: '',
  lastName: '',
  contactPhone1: ''
}

const TaskStoreProviderManager = ({ homePrData, ...props }) => {
  const { getMyEvents, taskIsLoading } = useTaskApis()
  const [list, setList] = useState([])
  const [filter, setFilter] = useStateCallback(INIT_FILTER)
  const [isClosedTasks, setIsClosedTasks] = useStateCallback(false)
  const [pagination, setPagination] = useStateCallback({
    page: 0,
    pageCount: 0
  })

  const onPaginationChange = page =>
    setPagination(
      prevState => ({ ...prevState, page }),
      updated => {
        getMyTasks(filter, updated)()
      }
    )

  useEffect(() => {
    getMyTasks()()
  }, [filter])

  const onChangeFilter = event => {
    const { name, value } = event.target

    if (name === 'globalId')
      return setFilter(prevState => ({ ...prevState, [name]: value?.toNum() }))

    if (name === 'types' && value.length === 0)
      return setFilter(prevState => ({
        ...prevState,
        [name]: [CS_CALL_CLIENT, CS_MEET_CLIENT]
      }))

    return setFilter(prevState => ({ ...prevState, [name]: value }))
  }

  const getMyTasks =
    (data = filter, pages = pagination, completed = isClosedTasks) =>
    async () => {
      const filter = clearObject(data)

      await getMyEvents({
        data: {
          ...filter,
          completed
        },
        limit: 10,
        offset: pages.page * 10,
        onSuccess: response => {
          setList(response.data?.listEvents || [])
          setPagination({
            ...pages,
            pageCount: Math.ceil(response.data?.countFiltered / 10) || 0
          })
        }
      })
    }

  const onSetIsClosedTasks = (bool = false) => {
    setIsClosedTasks(bool, () => {
      setPagination(
        prevState => ({ ...prevState, page: 0 }),
        updated => {
          getMyTasks(filter, updated, bool)()
        }
      )
    })
  }

  const taskStore = {
    filter,
    list,
    isClosedTasks,
    loading: taskIsLoading,
    pagination
  }

  const taskStoreFunc = {
    reload: getMyTasks(),
    onChangeFilter,
    onSetIsClosedTasks,
    onPaginationChange
  }

  return (
    <TaskStoreContext.Provider value={{ taskStore, taskStoreFunc }}>
      {props.children}
    </TaskStoreContext.Provider>
  )
}

export default TaskStoreProviderManager

export const useTaskStoreManager = () => useContext(TaskStoreContext)
